// app/not-found.jsx
"use client";

import Link from "next/link";

export default function NotFound() {
    return (
        <main className="min-h-screen flex flex-col items-center justify-center text-center p-8">
            <h1 className="text-5xl font-bold text-red-600 mb-4">404</h1>
            <h2 className="text-2xl font-semibold mb-2">Page Not Found</h2>
            <p className="text-neutral-600 dark:text-neutral-400 mb-6 max-w-md">
                The page you’re looking for doesn’t exist or has been moved.
            </p>
            <Link
                href="/"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl transition"
            >
                Go Home
            </Link>
        </main>
    );
}
